/** @module csi/widget/TableDimensions */
define([
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_Widget",
	"dojo/text!./TableDimensions.html",
	"csi/locale"
], function(declare, _TemplatedMixin, _Widget, template, locale) {

	return declare([_Widget, _TemplatedMixin], {
		templateString: template,

		/** @property {number} initialSelectedRows - initially selected number of rows */
		initialSelectedRows: 1,

		/** @property {number} initialSelectedColumns - initially selected number of columns */
		initialSelectedColumns: 1,

		/** @property {number} initialDisplayRows - initially displayed number of table dimension rows */
		initialDisplayRows: 1,

		/** @property {number} initialDisplayColumns - initially displayed number of table dimension columns */
		initialDisplayColumns: 1,

		/** @property {number} maxRows - max number of rows in table dimensions widget */
		maxRows: 1,

		/** @property {number} maxColumns - max number of columns in table dimensions widget */
		maxColumns: 1,

		/** @property {number} _selectedRow - row currently hovered over in table dimensions widget */
		_selectedRow: null,

		/** @property {number} _selectedColumn - column currently hovered over in table dimensions widget */
		_selectedColumn: null,

		_setDimensionsLabelAttr: {node: "tableDimensionsStringNode", type: "innerText"},

		postCreate: function() {
			this.inherited(arguments);
			this._updateCells();

			this.on("mousemove", function(event) {
				var targetId = $(event.target).attr('id');

				if (/^\d+_\d+$/.test(targetId)) {
					this._updateCells(targetId);
				}
			});

			this.on("mouseleave", function(event) {
				this.reset();
			});
		},

		reset: function() {
			this._selectedRow = null;
			this._selectedColumn = null;
			this._updateCells();
		},

		_updateCells: function(cellId) {
			cellId = cellId || (this.initialSelectedRows + "_" + this.initialSelectedColumns);

			if (cellId) {
				// We use the cell ID parts to know which cell mouse is over.
				var cellIdParts = cellId.split('_');
				this._selectedRow = parseInt(cellIdParts[0]);
				this._selectedColumn = parseInt(cellIdParts[1]);

				// Always start by removing all cells from the container.
				$(this.tableDimensionsCellsNode).empty();

				// Number of rows to draw will be initialDisplayRows, but if user hovers over the last
				// initially displayed row, then add another row, whose cells will be all unselected.
				var rowsToDraw = this._selectedRow >= this.initialDisplayRows ? this._selectedRow + 1 : this.initialDisplayRows;

				// rows to draw should not exceed maxRows
				rowsToDraw = Math.min(rowsToDraw, this.maxRows);

				// Number of columns to draw will be initialDisplayColumnss, but if user hovers over the last
				// initially displayed column, then add another column, whose cells will be all unselected.
				var columnsToDraw = this._selectedColumn >= this.initialDisplayColumns ? this._selectedColumn + 1 : this.initialDisplayColumns;

				// columns to draw should not exceed maxColumns
				columnsToDraw = Math.min(columnsToDraw, this.maxColumns);

				for (var idx1 = 1; idx1 <= rowsToDraw; idx1++) {
					// Create the div for the row of cells.
					var rowDiv = $('<div class="csi-table-dimensions-row"></div>');

					for (var idx2 = 1; idx2 <= columnsToDraw; idx2++) {
						// Create an empty cell.
						var cell = $('<div></div>');

						// Set the id of the cell to the row and column.
						cell.attr('id', (idx1) + '_' + (idx2));

						if (idx1 <= cellIdParts[0] && idx2 <= cellIdParts[1]) {
							cell.addClass("csi-table-dimensions-filled-cell");
						} else {
							cell.addClass("csi-table-dimensions-empty-cell");
						}

						// Append the cell to the row div.
						rowDiv.append(cell);
					}

					// The row is full, so append it to the cell container.
					$(this.tableDimensionsCellsNode).append(rowDiv);
				}
				this._updateDimensionLabel();
			}
		},

		_updateDimensionLabel: function() {
			this.set("dimensionsLabel", locale.resource("TableDimensions", [this._selectedRow, this._selectedColumn]));
		},

		_getTableDimensions: function() {
			return {
				tableDimensions: {
					rows: this._selectedRow,
					columns: this._selectedColumn
				}
			};
		}
	});
});
